// extracted by mini-css-extract-plugin
export default {"info":"HelloWorld_info__czZTV"};